import React from "react";
import { oneOf } from "prop-types";

import ListingCardHorizontal from "./components/ListingCardHorizontal";
import ListingCardVertical from "./components/ListingCardVertical";

const ListingCard = props => (
  <>
    {props.theme === "horizontalCard" && <ListingCardHorizontal {...props} />}
    {props.theme === "verticalCard" && <ListingCardVertical {...props} />}
  </>
);

ListingCard.defaultProps = {
  theme: "verticalCard"
};

ListingCard.propTypes = {
  theme: oneOf(["horizontalCard", "verticalCard"])
};

export default ListingCard;
